const paramParse = (cmd) => {
    return cmd.trim().replace('  ', ' ').split(' ');
}

export{
    paramParse
}